interface ToastProps {
  message: string;
}

export default function Toast({ message }: ToastProps) {
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="animate-toast-in fixed bottom-8 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-2 rounded-full bg-primary-900 px-4 py-2.5 text-[13px] text-background-50"
    >
      <i className="ri-checkbox-circle-line text-base text-accent-300" />
      {message}
    </div>
  );
}